export default "__VITE_ASSET__7035578c__"